import { MainNavigation } from 'components/navigation/MainNavigation/index.js';
import type { TMenuItem } from 'components/navigation/NavMenuItem/index.js';
import { SideBar } from 'components/navigation/SideBar/index.js';
import type { FC } from 'react';

interface NavigationBarProps {
  menuButtons: TMenuItem[];
  isNavOpen: boolean;
}

export const NavigationBar: FC<NavigationBarProps> = ({
  menuButtons,
  isNavOpen,
}) => {
  return (
    <SideBar isNavOpen={isNavOpen}>
      <MainNavigation menuButtons={menuButtons} />
    </SideBar>
  );
};

NavigationBar.displayName = 'NavigationBar';
